import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(values: any, ...args: any[]): any {
    const sortBy = args[0];
    const isCalsSort = sortBy === 'cals';

    if (values.length > 0) {
      const result = values.sort((a, b) => {

        // Sort by cals if the sort is not by cals and
        // the value is the same for both items
        if (!isCalsSort && a[sortBy] === b[sortBy]) {
          return this.returnSort(a.cals, b.cals);
        }

        // Sort by time if the sort is by cals and
        // the value is the same for both items
        if (isCalsSort && a[sortBy] === b[sortBy]) {
          return this.returnSort(a.time, b.time, true);
        }

        return this.returnSort(a[sortBy], b[sortBy], isCalsSort);
      });
      return result;
    }

    return null;
  }

  returnSort(a: string, b: string, invert?: boolean) {
    const isFirefox = navigator.userAgent.indexOf('Firefox') > -1;

    if (a === undefined || b === undefined) {
      return a;
    }

    if (invert) {
      return isFirefox ?
        a > b ? false : true :
        a > b ? -1 : 0;
    }

    return isFirefox ?
          a > b ? true : false :
          a > b ? 0 : -1;
  }
}
